export default [
    {
        id: 0,
        descripcion: 'NO',
        style: 'secondary'
    },
    {
        id: 1,
        descripcion: 'SI',
        style: 'primary'
    }
]